import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebase/firebaseConfig";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import routePaths from "../../../routes/routePaths";

export default function HomeSchedulePreview() {
  const { i18n, t } = useTranslation();
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const ref = doc(db, "sections", "schedule_intro");
      const snap = await getDoc(ref);
      if (snap.exists()) setData(snap.data());
    };
    fetchData();
  }, []);

  if (!data) return null;

  return (
    <section className="bg-secondary/10 py-14 px-4 text-center">
      <h2 className="text-2xl md:text-3xl font-extrabold mb-6 text-primary">
        {data.title?.[i18n.language] || data.title?.vi}
      </h2>
      <div
        className="text-base max-w-xl mx-auto text-left space-y-2 text-menu"
        dangerouslySetInnerHTML={{ __html: data.content?.[i18n.language] || data.content?.vi }}
      />
      <button
        className="
          bg-primary text-textButton font-bold px-8 py-3 rounded shadow-sm
          transition
          hover:bg-secondary hover:text-primary
        "
        onClick={() => navigate(routePaths.schedule)}
      >
        {t("home.scheduleBtn")}
      </button>
    </section>
  );
}
